import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: Home,
    children: [
      {
        path: '/',
        meta: {
          menuIndex: '1'
        },
        component: () => import('@/views/LandingPage.vue')
      },
      {
        path: '/landingPage',
        name: 'landingPage',
        meta: {
          menuIndex: '1'
        },
        component: () => import('@/views/LandingPage.vue')
      },
      {
        path: '/downCenter',
        name: 'downCenter',
        meta: {
          menuIndex: '12'
        },
        component: () => import('@/views/downCenter.vue')
      },
      {
        path: '/reservation',
        name: 'reservation',
        meta: {
          menuIndex: '1-2'
        },
        component: () => import('@/views/Reservation.vue')
      },
      {
        path: '/resetPass',
        name: 'resetPass',
        meta: {
          menuIndex: '1-3'
        },
        component: () => import('@/views/resetPass.vue')
      },
      
      {
        path: '/magezine',
        name: 'magezine',
        meta: {
          menuIndex: '2-2'
        },
        component: () => import('@/views/MagezineInfo.vue')
      },
      {
        path: '/company',
        name: 'company',
        meta: {
          menuIndex: '2-1'
        },
        component: () => import('@/views/companyInfo.vue')
      },
      {
        path: '/product',
        name: 'product',
        meta: {
          menuIndex: '2-3'
        },
        component: () => import('@/views/product/Product.vue')
      },
      {
        path: '/productList',
        name: 'productList',
        meta: {
          menuIndex: '2-3'
        },
        component: () => import('@/views/product/ProductList.vue')
      },
      {
        path: '/addProduct',
        name: 'addProduct',
        meta: {
          menuIndex: '2-3'
        },
        component: () => import('@/views/product/AddProduct.vue')
      },
      {
        path: '/catalog',
        name: 'catalog',
        component: () => import('@/views/company/catalog.vue')
      },
      {
        path: '/boardInfo',
        name: 'boardInfo',
        meta: {
          menuIndex: '3-1'
        },
        component: () => import('@/views/board/boardInfo.vue')
      },
      {
        path: '/tz',
        name: 'tz',
        meta: {
          menuIndex: '3-2'
        },
        component: () => import('@/views/board/tz.vue')
      },

      {
        path: '/electric',
        name: 'electric',
        meta: {
          menuIndex: '3-3'
        },
        component: () => import('@/views/board/electric.vue')
      },
      {
        path: '/exhibition',
        name: 'exhibition',
        meta: {
          menuIndex: '3-4'
        },
        component: () => import('@/views/board/exhibition.vue')
      },
      {
        path: '/card',
        name: 'card',
        meta: {
          menuIndex: '4'
        },
        component: () => import('@/views/card/Card.vue')
      },
      {
        path: '/lzCode',
        name: 'LzCode',
        meta: {
          menuIndex: '7'
        },
        component: () => import('@/views/lzCode/index.vue')
      },
      {
        path: '/addCard',
        name: 'addCard',
        meta: {
          menuIndex: '4'
        },
        component: () => import('@/views/card/AddCard.vue')
      },
      {
        path: '/activityList',
        name: 'activityList',
        meta: {
          menuIndex: '5'
        },
        component: () => import('@/views/active/activityList.vue')
      },
      {
        path: '/hotel',
        name: 'hotel',
        meta: {
          menuIndex: '9'
        },
        component: () => import('@/views/service/hotel.vue')
      },
      
      {
        path: '/activityList/edit',
        name: 'activityEdit',
        meta: {
          menuIndex: '5'
        },
        component: () => import('@/views/active/edit.vue')
      },
      {
        path: '/adBook',
        name: 'adBook',
        meta: {
          menuIndex: '6-1'
        },
        component: () => import('@/views/service/adBook.vue')
      },
      {
        path: '/fshow',
        name: 'fshow',
        meta: {
          menuIndex: '6-2'
        },
        component: () => import('@/views/service/fshow.vue')
      },
      {
        path: '/inviteCode',
        name: 'inviteCode',
        meta: {
          menuIndex: '8'
        },
        component: () => import('@/views/board/inviteCode.vue')
      },
      {
        path: '/yaoqing',
        name: 'yaoqing',
        meta: {
          menuIndex: '13'
        },
        component: () => import('@/views/board/yaoqing.vue')
      },

    ]
  },
  {
    path: '*',
    redirect: '/404'
  },
  {
    path: '/404',
    name: '404',
    component: () => import('@/views/404.vue')
  },
  {
    path: '/login',
    name: 'login',
    props: true,
    component: () => import('@/views/Login.vue')
  },
  {
    path: '/SignUp',
    name: 'singUp',
    component: () => import('@/views/singUp.vue')
  }
]

const router = new VueRouter({
  routes
})

export default router
